/* eslint-disable jsx-a11y/alt-text */
import { useMenuContext } from "context/MenuContext";

function BaseButton(props) {
  const { children, onClick, disabled, className, style, loading, ariaLabel, type } =
    props;

  return (
    <button
      aria-label={ariaLabel}
      className={className}
      onClick={onClick}
      disabled={disabled || loading}
      style={style}
      type={type}
    >
      {children}
    </button>
  );
}

export function PrimaryButton(props) {
  const { children, onClick, disabled, loading, ariaLabel, type } = props;
  const { navbarDesign } = useMenuContext();
  const backgroundColor = navbarDesign.backgroundColor;
  const textColor = navbarDesign.textColor;

  return (
    <BaseButton
      ariaLabel={ariaLabel}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      className="disabled:cursor-not-allowed disabled:opacity-75 flex justify-center items-center gap-1 w-full py-4 text-lg font-medium tracking-wide leading-tight uppercase rounded-lg shadow-md"
      style={{ backgroundColor, color: textColor }}
      type={type}
    >
      {loading && (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={"/loading-btn.svg"} />
      )}
      {children}
    </BaseButton>
  );
}

export function SecondaryButton(props) {
  const { children, onClick, disabled } = props;

  return (
    <BaseButton
      onClick={onClick}
      disabled={disabled}
      className="w-full py-4 bg-gray-300 text-lg text-black font-medium tracking-wide leading-tight uppercase rounded-lg shadow-md"
    >
      {children}
    </BaseButton>
  );
}

export function ComandaButton(props) {
  const { children, onClick, disabled } = props;

  return (
    <BaseButton
      onClick={onClick}
      disabled={disabled}
      className="bg-white
              text-black
                font-base
                py-1 px-5
                hover:bg-white
                rounded-lg
                border
                border-black
                "
    >
      {children}
    </BaseButton>
  );
}
